import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { Button } from "nlib/ui";
import { getTextsData } from "selectors/texts";
import { getUserBusinessesData } from "selectors/businesses";
import { useSelector } from "react-redux";
import IncludeExclude from "nlib/ui/IncludeExclude";
import IntegrationServices from "const/IntegrationServices";
import Modal, { ModalFooter } from "nlib/ui/Modal";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Texts from "utils/Texts";
import classNames from "classnames";

const MAX_COMPACT_OPTIONS = 3;

const SelectedBusinessesWindow = ({ service, businessesList, onClose }) => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const userBusinessesData = useSelector(getUserBusinessesData);

  const [selectedItems, setSelectedItem] = useState([]);

  const serviceInfo = useMemo(() => IntegrationServices.getByValue(service), [service]);

  const Icon = useMemo(() => () => <img alt="" className={Css.logo} src={serviceInfo.logo} />, [serviceInfo]);

  const connectedBusinessIds = useMemo(() => {
    return businessesList.filter((businessData) => {
      return userBusinessesData.some(({
        extraData: {
          xeroOrganizationId,
          quickBooksRealmId,
          zohoOrganizationId
        } = {}
      }) => {
        return [xeroOrganizationId, quickBooksRealmId, zohoOrganizationId].includes(businessData.itemId);
      });
    }).map(({ itemId }) => itemId);
  }, [businessesList, userBusinessesData]);

  const options = useMemo(() => {
    return businessesList.map((businessData) => ({
      value: businessData.itemId,
      label: businessData.businessName
    }));
  }, [businessesList]);

  const handleConnectButtonClick = useCallback(() => {
    onClose(selectedItems);
  }, [selectedItems, onClose]);

  const handleCloseClick = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    setSelectedItem(connectedBusinessIds);
  }, [connectedBusinessIds]);

  return (
    <Modal
      className={Css.selectedBusinessesWindow}
      iconComponent={Icon}
      title={Texts.replaceVars(uiTexts.selectServiceBusinesses, { service: serviceInfo.label })}
      onClose={handleCloseClick}>
      {!!options.length && (
        <div className={Css.description}>{messages.selectIntegrationBusinessesDescription}</div>
      )}
      <div className={classNames(Css.content, options.length <= MAX_COMPACT_OPTIONS && Css.compact)}>
        {options.length
          ? (
            <IncludeExclude
              className={Css.select}
              options={options}
              value={selectedItems}
              selectedLabel={uiTexts.selected}
              onChange={setSelectedItem} />
          )
          : (
            <div className={Css.noDataContent}>
              <div>
                <div><Icons.Briefcase /></div>
                <div>{uiTexts.noData}</div>
              </div>
            </div>
          )}
      </div>
      {!!options.length && (
        <div className={Css.planNote}>{messages.selectIntegrationBusinessesPlanNote}</div>
      )}
      <ModalFooter>
        <Button
          large primary
          disabled={!selectedItems.length}
          onClick={handleConnectButtonClick}>
          {selectedItems.length && selectedItems.every((id) => connectedBusinessIds.includes(id))
            ? uiTexts.reconnectSelected : uiTexts.connectSelected}
        </Button>
        <Button large onClick={handleCloseClick}>
          {uiTexts.cancel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default React.memo(SelectedBusinessesWindow);
